"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8483,7643],{

/***/ 37643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ pushGoogleTabEvent; },
/* harmony export */   "s": function() { return /* binding */ createHomeArticlePayload; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var logging_log_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15079);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var pushGoogleTabEvent = function pushGoogleTabEvent(eventName, payload) {
  if (true) {
    var _window = window,
        dataLayer = _window.dataLayer;

    if (dataLayer) {
      try {
        dataLayer.push(_objectSpread(_objectSpread({}, payload), {}, {
          event: eventName
        }));
        console.log("success", _objectSpread(_objectSpread({}, payload), {}, {
          event: eventName
        }));
      } catch (error) {
        logging_log_util__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error("error tab manager -> unable to push event", error);
      }
    } else {
      logging_log_util__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error("error tab manager -> unable to find datalayer in window");
    }
  } else {}
};

var getPostType = function getPostType(postType) {
  if (postType === "text") {
    return "Read";
  } else if (postType === "video") {
    return "Video";
  } else if (postType === "audio") {
    return "Audio";
  } else if (postType) {
    return "Visual Stories";
  } else {
    return "Undefined";
  }
};

var createHomeArticlePayload = function createHomeArticlePayload(postStateData, extraInfo) {
  var _postStateData$hashta;

  var payload = {
    "Content ID": postStateData === null || postStateData === void 0 ? void 0 : postStateData._id,
    "Title": postStateData === null || postStateData === void 0 ? void 0 : postStateData.title,
    "Category": postStateData === null || postStateData === void 0 ? void 0 : postStateData.categoryName,
    "Sub Category": postStateData === null || postStateData === void 0 ? void 0 : postStateData.subCategoryName,
    // "Author name": "",
    // "Published Date": postStateData?.createdAt?.toLocaleDateString(),
    // "Published Time": postStateData?.createdAt?.toLocaleTimeString(),
    // "Published Date": (new Date(postStateData?.createdAt))?.toLocaleDateString(),
    // "Published Time": (new Date(postStateData?.createdAt))?.toLocaleTimeString(),
    "Published Date": postStateData === null || postStateData === void 0 ? void 0 : postStateData.createdAt,
    "Published Time": postStateData === null || postStateData === void 0 ? void 0 : postStateData.createdAt,
    "Hashtag Linked": postStateData === null || postStateData === void 0 ? void 0 : (_postStateData$hashta = postStateData.hashtags) === null || _postStateData$hashta === void 0 ? void 0 : _postStateData$hashta.join(" "),
    "Author Name": postStateData === null || postStateData === void 0 ? void 0 : postStateData.postedByName,
    "Share": postStateData === null || postStateData === void 0 ? void 0 : postStateData.shareCount,
    "Likes": postStateData === null || postStateData === void 0 ? void 0 : postStateData.likeCount,
    "Bookmarks": postStateData === null || postStateData === void 0 ? void 0 : postStateData.isBookmarked
  };

  if (extraInfo !== null && extraInfo !== void 0 && extraInfo.Section) {
    return _objectSpread(_objectSpread({}, payload), {}, {
      Section: extraInfo === null || extraInfo === void 0 ? void 0 : extraInfo.Section
    });
  } else {
    payload.Section = getPostType(postStateData === null || postStateData === void 0 ? void 0 : postStateData.type);
    return payload;
  }
}; // Bookmarks

/***/ }),

/***/ 99126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O8": function() { return /* binding */ apstagBidCallback; },
/* harmony export */   "PI": function() { return /* binding */ createApsSlotsRosMobile; },
/* harmony export */   "VG": function() { return /* binding */ createApsSlotsRosDesktop; },
/* harmony export */   "WX": function() { return /* binding */ requestBiddingFromPWT; },
/* harmony export */   "Zy": function() { return /* binding */ createApsSlotsHomeMobile; },
/* harmony export */   "we": function() { return /* binding */ createApsSlotsHomeDesktop; }
/* harmony export */ });
/* unused harmony exports DEFAULT_HOME_MOBILE, createApsSlotsRosDesktopFalse, createApsSlotsRosMobileFalse */
// import { logger } from "./logging/log-util";
var requestBiddingFromPWT = function requestBiddingFromPWT() {
  console.log("AdsTest requestBiddingFromPWT"); // logger.info("requestBiddingFromPWT");

  if (typeof PWT.requestBids === "function") {
    console.log("AdsTest requestBiddingFromPWT inside if");
    PWT.requestBids(PWT.generateConfForGPT(googletag.pubads().getSlots()), function (adUnitsArray) {
      // logger.info("bids received from PWT", adUnitsArray);
      PWT.addKeyValuePairsToGPTSlots(adUnitsArray);
      PWT.ow_BidsReceived = true;
      window.initAdserver(false);
    });
  }

  var FAILSAFE_TIMEOUT = 1000; // this timeout should > OpenWrap and TAM timeout

  setTimeout(function () {
    window.initAdserver(true); // calling this function with forced mode set to true so that GPT API is always executed
  }, FAILSAFE_TIMEOUT);
};
function apstagBidCallback(bids) {
  // logger.info("apstagBidCallback - received bids", bids);
  googletag.cmd.push(function () {
    apstag.setDisplayBids();
    PWT.TAM_BidsReceived = true;
    window.initAdserver(false);
  });
}
var DEFAULT_HOME_MOBILE = [{
  slotID: "div-gpt-ad-1657866020444-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866205249-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866282643-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866338810-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866406380-0",
  sizes: [[300, 250]]
}, {
  slotID: "div-gpt-ad-1657866608917-0",
  sizes: [[320, 50]]
}];
var createApsSlotsRosDesktopFalse = function createApsSlotsRosDesktopFalse(_ref) {
  var _ref$atf = _ref.atf,
      atf = _ref$atf === void 0 ? false : _ref$atf,
      _ref$atf2 = _ref.atf300,
      atf300 = _ref$atf2 === void 0 ? false : _ref$atf2,
      _ref$mtf = _ref.mtf1,
      mtf1 = _ref$mtf === void 0 ? false : _ref$mtf,
      _ref$mtf2 = _ref.mtf2,
      mtf2 = _ref$mtf2 === void 0 ? false : _ref$mtf2,
      _ref$mtf3 = _ref.mtf3,
      mtf3 = _ref$mtf3 === void 0 ? false : _ref$mtf3,
      _ref$btf = _ref.btf,
      btf = _ref$btf === void 0 ? false : _ref$btf;
  createApsSlotsRosDesktop({
    atf: atf,
    atf300: atf300,
    mtf1: mtf1,
    mtf2: mtf2,
    mtf3: mtf3,
    btf: btf
  });
};
var createApsSlotsRosDesktop = function createApsSlotsRosDesktop(_ref2) {
  var _ref2$atf = _ref2.atf,
      atf = _ref2$atf === void 0 ? true : _ref2$atf,
      _ref2$atf2 = _ref2.atf300,
      atf300 = _ref2$atf2 === void 0 ? true : _ref2$atf2,
      _ref2$mtf = _ref2.mtf1,
      mtf1 = _ref2$mtf === void 0 ? true : _ref2$mtf,
      _ref2$mtf2 = _ref2.mtf2,
      mtf2 = _ref2$mtf2 === void 0 ? true : _ref2$mtf2,
      _ref2$mtf3 = _ref2.mtf3,
      mtf3 = _ref2$mtf3 === void 0 ? true : _ref2$mtf3,
      _ref2$btf = _ref2.btf,
      btf = _ref2$btf === void 0 ? true : _ref2$btf;
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701945163318-0",
      sizes: [[728, 90]]
    });
  }

  if (atf300) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-1",
      sizes: [[728, 90]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-2",
      sizes: [[728, 90]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-3",
      sizes: [[728, 90]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701945864013-0",
      sizes: [[728, 90]]
    });
  }

  console.log("slotss 1s", slots);
  return slots;
}; // Just a warpper with default false value

var createApsSlotsRosMobileFalse = function createApsSlotsRosMobileFalse(_ref3) {
  var _ref3$atf = _ref3.atf,
      atf = _ref3$atf === void 0 ? false : _ref3$atf,
      _ref3$mtf = _ref3.mtf1,
      mtf1 = _ref3$mtf === void 0 ? false : _ref3$mtf,
      _ref3$mtf2 = _ref3.mtf2,
      mtf2 = _ref3$mtf2 === void 0 ? false : _ref3$mtf2,
      _ref3$mtf3 = _ref3.mtf3,
      mtf3 = _ref3$mtf3 === void 0 ? false : _ref3$mtf3,
      _ref3$btf = _ref3.btf,
      btf = _ref3$btf === void 0 ? false : _ref3$btf,
      _ref3$bottom = _ref3.bottom,
      bottom = _ref3$bottom === void 0 ? false : _ref3$bottom;
  console.log("atf,mtf", atf, mtf1, mtf2, mtf3, btf, bottom);
  createApsSlotsRosMobile({
    atf: atf,
    mtf1: mtf1,
    mtf2: mtf2,
    mtf3: mtf3,
    btf: btf,
    bottom: bottom
  });
};
var createApsSlotsRosMobile = function createApsSlotsRosMobile(_ref4) {
  var _ref4$atf = _ref4.atf,
      atf = _ref4$atf === void 0 ? true : _ref4$atf,
      _ref4$mtf = _ref4.mtf1,
      mtf1 = _ref4$mtf === void 0 ? true : _ref4$mtf,
      _ref4$mtf2 = _ref4.mtf2,
      mtf2 = _ref4$mtf2 === void 0 ? true : _ref4$mtf2,
      _ref4$mtf3 = _ref4.mtf3,
      mtf3 = _ref4$mtf3 === void 0 ? true : _ref4$mtf3,
      _ref4$btf = _ref4.btf,
      btf = _ref4$btf === void 0 ? true : _ref4$btf,
      _ref4$bottom = _ref4.bottom,
      bottom = _ref4$bottom === void 0 ? true : _ref4$bottom;
  console.log("calsfdwsdf");
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-1",
      sizes: [[300, 250]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-2",
      sizes: [[300, 250]]
    });
  } // if (mtf3) {
  //   slots.push({
  //     slotID: "div-gpt-ad-1701946028239-3",
  //     sizes: [[300, 250]],
  //   });
  // }


  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-3",
      sizes: [[300, 250]]
    });
  }

  if (bottom) {
    slots.push({
      slotID: "div-gpt-ad-1701946324333-0",
      sizes: [[320, 50]]
    });
  }

  return slots;
};
var createApsSlotsHomeDesktop = function createApsSlotsHomeDesktop(_ref5) {
  var _ref5$atf = _ref5.atf,
      atf = _ref5$atf === void 0 ? true : _ref5$atf,
      _ref5$atf2 = _ref5.atf300,
      atf300 = _ref5$atf2 === void 0 ? true : _ref5$atf2,
      _ref5$mtf = _ref5.mtf1,
      mtf1 = _ref5$mtf === void 0 ? true : _ref5$mtf,
      _ref5$mtf2 = _ref5.mtf2,
      mtf2 = _ref5$mtf2 === void 0 ? true : _ref5$mtf2,
      _ref5$mtf3 = _ref5.mtf3,
      mtf3 = _ref5$mtf3 === void 0 ? true : _ref5$mtf3,
      _ref5$btf = _ref5.btf,
      btf = _ref5$btf === void 0 ? true : _ref5$btf;
  console.log("AdsTest createApsSlotsHomeDesktop");
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701945163318-0",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (atf300) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-0",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-1",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-2",
      sizes: [[728, 90], [970, 250], [970, 90]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-4",
      sizes: [[728, 90], [970, 90]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701945220410-3",
      sizes: [[300, 250]]
    });
  }

  console.log("AdsTest createApsSlotsHomeDesktop slots are", slots);
  return slots;
};
var createApsSlotsHomeMobile = function createApsSlotsHomeMobile(_ref6) {
  var _ref6$atf = _ref6.atf,
      atf = _ref6$atf === void 0 ? true : _ref6$atf,
      _ref6$mtf = _ref6.mtf1,
      mtf1 = _ref6$mtf === void 0 ? true : _ref6$mtf,
      _ref6$mtf2 = _ref6.mtf2,
      mtf2 = _ref6$mtf2 === void 0 ? true : _ref6$mtf2,
      _ref6$mtf3 = _ref6.mtf3,
      mtf3 = _ref6$mtf3 === void 0 ? true : _ref6$mtf3,
      _ref6$btf = _ref6.btf,
      btf = _ref6$btf === void 0 ? true : _ref6$btf,
      _ref6$bottom = _ref6.bottom,
      bottom = _ref6$bottom === void 0 ? true : _ref6$bottom;
  var slots = [];

  if (atf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-0",
      sizes: [[300, 250]]
    });
  }

  if (mtf1) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-1",
      sizes: [[300, 250]]
    });
  }

  if (mtf2) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-2",
      sizes: [[300, 250]]
    });
  }

  if (mtf3) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-4",
      sizes: [[300, 250]]
    });
  }

  if (btf) {
    slots.push({
      slotID: "div-gpt-ad-1701946028239-3",
      sizes: [[300, 250]]
    });
  }

  if (bottom) {
    slots.push({
      slotID: "div-gpt-ad-1701946324333-0",
      sizes: [[320, 50]]
    });
  }

  return slots;
};

/***/ }),

/***/ 52821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96781);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var AdContainer = function AdContainer(_ref) {
  var _ref$divId = _ref.divId,
      divId = _ref$divId === void 0 ? "" : _ref$divId;
  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_1__/* .useWindowSize */ .iP)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: "container-row py-2 text-center",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      style: {
        fontSize: "11px",
        color: "#b7b7b7",
        marginBottom: "0px"
      },
      children: "Advertisement"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      id: "".concat(divId),
      style: {
        minWidth: "300px",
        minHeight: size.width > 600 ? "100px" : "260px",
        display: "block !important"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
        type: "text/javascript",
        defer: true,
        dangerouslySetInnerHTML: {
          __html: "{googletag.cmd.push(function() { googletag.display('".concat(divId, "')})")
        }
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AdContainer);

/***/ }),

/***/ 74771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mainContainer; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(2185);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/newsCard/ReadNewsCardNew/index.js
var ReadNewsCardNew = __webpack_require__(43063);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/homePage/goodMorning/ftafatModal/index.js
var ftafatModal = __webpack_require__(29778);
// EXTERNAL MODULE: ./src/api/googletab.js
var googletab = __webpack_require__(37643);
// EXTERNAL MODULE: ./src/api/constants.js
var constants = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/homePage/goodMorning/goodmorning.js
 // import Link from "next/link";

 //import { useSelector } from "react-redux";
// import { useSession } from "next-auth/react";
// import { getLanguage } from "localization/i8intl";
// import { useSelector } from "react-redux";









var GoodMorning = function GoodMorning() {
  var _router$query;

  var size = (0,commonConstants/* useWindowSize */.iP)();
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([]),
      fatafatPosts = _useState[0],
      setFatafatPosts = _useState[1];

  var _useState2 = (0,react.useState)(false),
      shouldShow = _useState2[0],
      setShouldShow = _useState2[1];

  var queryIndex = (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.index ? parseInt(router.query.index) : 0;

  var _useState3 = (0,react.useState)(false),
      firstScroll = _useState3[0],
      setFirstScroll = _useState3[1];

  (0,react.useEffect)(function () {
    function handleScroll() {
      setFirstScroll(true);
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, []);

  var handleClick = function handleClick() {
    (0,googletab/* pushGoogleTabEvent */.I)("homepage_fatafat_open", {});
    setShouldShow(false);
    router.push("/"); // setShow((e) => !e);
  };

  var openHandler = function openHandler() {
    if (fatafatPosts && (fatafatPosts === null || fatafatPosts === void 0 ? void 0 : fatafatPosts.length) > 0) {
      var _fatafatPosts$, _fatafatPosts$2, _fatafatPosts$3;

      setShouldShow(true);
      router.push("?fatafat=".concat((_fatafatPosts$ = fatafatPosts[0]) === null || _fatafatPosts$ === void 0 ? void 0 : _fatafatPosts$.postSlug, "&index=0"), "/".concat((_fatafatPosts$2 = fatafatPosts[0]) === null || _fatafatPosts$2 === void 0 ? void 0 : _fatafatPosts$2.categorySlug, "/post/").concat((_fatafatPosts$3 = fatafatPosts[0]) === null || _fatafatPosts$3 === void 0 ? void 0 : _fatafatPosts$3.postSlug), {
        shallow: true
      });
    } else {
      fatafatHandler();
      setShouldShow(true);
    }
  };

  var fatafatHandler = function fatafatHandler() {
    fetch("".concat(constants/* baseUrl */.FH, "/post/allFatafat?limit=9&skip=1&type=text")).then(function (res) {
      return res.json();
    }).then(function (d) {
      var _d$result;

      setFatafatPosts(d === null || d === void 0 ? void 0 : (_d$result = d.result) === null || _d$result === void 0 ? void 0 : _d$result.entities);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      onClick: openHandler,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        src: "https://static.thelallantop.com/images/post/1690877763030_fatafat-jpg.webp?&quality=70&width=".concat(firstScroll ? 500 : 100),
        className: "bannerImage fatafatGif",
        fetchpriority: "high",
        alt: "banner"
      })
    }), fatafatPosts && fatafatPosts.length > 0 && shouldShow && /*#__PURE__*/(0,jsx_runtime.jsx)(ftafatModal/* default */.Z, {
      show: shouldShow,
      fatafatPosts1: fatafatPosts,
      onClick: function onClick() {
        handleClick();
      },
      queryIndex: queryIndex
    })]
  });
};

/* harmony default export */ var goodmorning = (GoodMorning);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
;// CONCATENATED MODULE: ./src/components/newsBanner/Type2.js
// import { Carousel } from "react-bootstrap";
// import Link from "next/link";
//import OptionDropdown from "components/category/about/optionDropdown/optionDropdown";
 // import { postLike } from "redux/actions/postAction";

 // import { useAmp } from "next/amp";
// import CustomPopup from "components/shared/modal/customPopup";
// import { useSession } from "next-auth/react";
// import { getLanguage } from "localization/i8intl";

 // import ReactPlaceholder from 'react-placeholder';
// import "react-placeholder/lib/reactPlaceholder.css";






var NewsImageTextBanner1 = function NewsImageTextBanner1(_ref) {
  var _postStateData$catego, _postData$liveBlogDat, _postData$title, _postData$title2, _postData$title3;

  var postData = _ref.postData,
      hTag = _ref.hTag;
  console.log("NewsImageTextBanner1", postData); //const sessionData = JSON.parse(localStorage.getItem("lallantopSession2"));

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(200),
      imageSize = _useState[0],
      setImageSize = _useState[1];

  var query = router.query; // const { data: session } = useSession();
  // const { userLocalDetail } = useSelector(({ AuthReducer }) => AuthReducer);
  // const [loginPrompt, setLoginPrompt] = useState(false);
  // const [videoDuration, setVideoDuration] = useState(0);

  var _useState2 = (0,react.useState)(postData),
      postStateData = _useState2[0],
      setPostStateData = _useState2[1]; // const [openShareModal, setOpenShareModal] = useState(false);
  //const [shareData, setShareData] = useState({});


  var _useSelector = (0,es/* useSelector */.v9)(function (_ref2) {
    var PostReducer = _ref2.PostReducer;
    return PostReducer;
  }),
      postDetails = _useSelector.postDetails;

  var isHomePath = router.asPath === "/";
  var pageToOpen = "/".concat((postStateData === null || postStateData === void 0 ? void 0 : (_postStateData$catego = postStateData.categorySlug) === null || _postStateData$catego === void 0 ? void 0 : _postStateData$catego.toLowerCase()) || (query === null || query === void 0 ? void 0 : query.categoryName), "/post/").concat((postStateData === null || postStateData === void 0 ? void 0 : postStateData.postSlug) || "");
  var ImageUrl = "data:image/webp;base64,UklGRmQCAABXRUJQVlA4WAoAAAAgAAAAxwAAxwAASUNDUMgBAAAAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADZWUDggdgAAAFAMAJ0BKsgAyAA/zebxc7+4M6ygSAPwOYlpbuF2sRtAE9r0VcIMghqqTXbaLhBkENVSa7bRcIMghqqTXbaLhBkENVSa7bRcIMghqqTXbaLhBkENVSa7bRcIMghqqTXbaLhBkENVSa7bRZwAAP7+yOAAAAAAAAA="; // const shareUrl = `${pageToOpen}?postId=${postStateData?._id}`;

  (0,react.useEffect)(function () {
    if ((postDetails === null || postDetails === void 0 ? void 0 : postDetails._id) === (postData === null || postData === void 0 ? void 0 : postData._id)) {
      setPostStateData(postDetails);
    }
  }, [postDetails, postData === null || postData === void 0 ? void 0 : postData._id]);

  var _useState3 = (0,react.useState)(false),
      firstScroll = _useState3[0],
      setFirstScroll = _useState3[1];

  (0,react.useEffect)(function () {
    if (firstScroll === false) {
      var handleScroll = function handleScroll() {
        setFirstScroll(true);
        window.removeEventListener("scroll", handleScroll);
      };

      window.addEventListener("scroll", handleScroll);
    }
  }, [firstScroll]);
  (0,react.useEffect)(function () {
    var timer = setTimeout(function () {
      setFirstScroll(true);
    }, 18000);
    return function () {
      clearTimeout(timer);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "headline-box1",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "headline-left-col",
        style: {
          position: "relative"
        },
        children: [postData.type === "liveblog" && (postData === null || postData === void 0 ? void 0 : (_postData$liveBlogDat = postData.liveBlogData) === null || _postData$liveBlogDat === void 0 ? void 0 : _postData$liveBlogDat.eventStatus) === "live" && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "assets/images/giphy.gif",
          style: {
            position: "absolute",
            width: "80px",
            zIndex: "99",
            height: "80px",
            right: "0",
            top: "-10px"
          },
          alt: "live"
        }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "headline-pic-box ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "".concat(postData.eventStatus === undefined ? pageToOpen : "/business/post/".concat(postData === null || postData === void 0 ? void 0 : postData.sefUrl)),
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: "headline-thumb",
              onClick: function onClick() {
                //console.log(isHomePath, "home path");
                if (isHomePath) {
                  (0,googletab/* pushGoogleTabEvent */.I)("lt_cards", (0,googletab/* createHomeArticlePayload */.s)(postStateData, {
                    Section: "Home"
                  })); // ClevertapReact.event(
                  //   "homepage_card",
                  //   createHomeCardPayload("homepage_card", postStateData)
                  // );
                } else if (router.asPath === "/video") {
                  //console.log("bdeio");
                  (0,googletab/* pushGoogleTabEvent */.I)("lt_cards", (0,googletab/* createHomeArticlePayload */.s)(postStateData, {
                    Section: "Video"
                  }));
                }
              },
              children: [(postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                // className={!firstScroll ? "shimmer-effect" : ""}
                src: firstScroll ? (postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) + "?width=360" : (postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) + "?width=70",
                alt: (postData === null || postData === void 0 ? void 0 : postData.imgAltText) || "News pic" // loading="lazy"
                ,
                fetchpriority: "high" // eslint-disable-next-line react/no-unknown-property

              }), (postData === null || postData === void 0 ? void 0 : postData.thumbnail) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                // className={!firstScroll ? "shimmer-effect" : ""}
                src: firstScroll ? (postData === null || postData === void 0 ? void 0 : postData.thumbnail) + "?width=360" : (postData === null || postData === void 0 ? void 0 : postData.thumbnail) + "?width=70",
                alt: (postData === null || postData === void 0 ? void 0 : postData.imgAltText) || "News pic",
                loading: "lazy" // fetchpriority="high"
                // eslint-disable-next-line react/no-unknown-property

              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "news-type-box",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                  className: "icon-".concat((postStateData === null || postStateData === void 0 ? void 0 : postStateData.type) === "text" || postData.type === "liveblog" ? "cat-read" : (postStateData === null || postStateData === void 0 ? void 0 : postStateData.type) === "audio" ? "mic" : "play-circle")
                }), (postStateData === null || postStateData === void 0 ? void 0 : postStateData.type) === "audio" && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: videoDuration
                })]
              })]
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "headline-right-col",
          style: {
            position: "relative"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "headline-body",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "headline-info",
              style: {
                paddingTop: "0.5rem",
                height: "6rem"
              },
              children: hTag === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                style: {
                  marginBottom: "0rem",
                  cursor: "pointer"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: postData.eventStatus === undefined ? pageToOpen : "/business/post/".concat(postData === null || postData === void 0 ? void 0 : postData.sefUrl) // query: {
                  //   categoryName: postStateData?.name,
                  //   postSlug: postStateData?.postSlug,
                  // },
                  ,
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    style: {
                      fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
                      fontStyle: "normal",
                      fontWeight: "550",
                      fontSize: "18px",
                      lineHeight: "135%",
                      color: "#000000"
                    },
                    children: postData === null || postData === void 0 ? void 0 : (_postData$title = postData.title) === null || _postData$title === void 0 ? void 0 : _postData$title.padEnd(88)
                  })
                })
              }) : hTag === 2 ? /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                style: {
                  marginBottom: "0rem",
                  cursor: "pointer"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: postData.eventStatus === undefined ? pageToOpen : "/business/post/".concat(postData === null || postData === void 0 ? void 0 : postData.sefUrl) // query: {
                  //   categoryName: postStateData?.name,
                  //   postSlug: postStateData?.postSlug,
                  // },
                  ,
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    style: {
                      fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
                      fontStyle: "normal",
                      fontWeight: "550",
                      fontSize: "18px",
                      lineHeight: "135%",
                      color: "#000000"
                    },
                    children: postData === null || postData === void 0 ? void 0 : (_postData$title2 = postData.title) === null || _postData$title2 === void 0 ? void 0 : _postData$title2.padEnd(88)
                  })
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                style: {
                  marginBottom: "0rem",
                  cursor: "pointer"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: postData.eventStatus === undefined ? pageToOpen : "/business/post/".concat(postData === null || postData === void 0 ? void 0 : postData.sefUrl) // query: {
                  //   categoryName: postStateData?.name,
                  //   postSlug: postStateData?.postSlug,
                  // },
                  ,
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    style: {
                      fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont",
                      fontStyle: "normal",
                      fontWeight: "550",
                      fontSize: "18px",
                      lineHeight: "135%",
                      color: "#000000"
                    },
                    children: postData === null || postData === void 0 ? void 0 : (_postData$title3 = postData.title) === null || _postData$title3 === void 0 ? void 0 : _postData$title3.padEnd(88)
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "line-newsImageTextBanner1",
              style: {
                height: "1px",
                background: "rgba(166, 166, 166, 0.2)",
                width: "100%"
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {})]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("style", {
      children: ".shimmer-effect {\n         color: grey;\n         display: inline-block;\n         /* adding gradients */\n         -webkit-mask: linear-gradient(120deg, #000 25%, #0005, #000 75%) right/250% 100%;\n         /* shimmer effect animation */\n         animation: shimmer 1.5s infinite;\n         background-repeat: no-repeat;\n         width: 500px;\n      }\n      @keyframes shimmer {\n         100% {\n            /* setting up mask position at left side */\n            -webkit-mask-position: left\n         }\n      }"
    })]
  });
};

/* harmony default export */ var Type2 = (NewsImageTextBanner1);
// EXTERNAL MODULE: ./node_modules/firebase/remote-config/dist/esm/index.esm.js + 4 modules
var index_esm = __webpack_require__(12971);
// EXTERNAL MODULE: ./src/utils/firebase.js
var firebase = __webpack_require__(18945);
// EXTERNAL MODULE: ./src/constants/MasterConfigContext.js
var MasterConfigContext = __webpack_require__(39712);
// EXTERNAL MODULE: ./src/constants/cricket.js
var cricket = __webpack_require__(34044);
;// CONCATENATED MODULE: ./src/components/cricket/NewsCarousel.jsx
// import { timeSince } from "constants/cardsConstant";




var colors = (/* unused pure expression or super */ null && (["green", "blue", "red"]));

var NewsCarousel = function NewsCarousel(_ref) {
  var newsData = _ref.newsData;

  var _useState = (0,react.useState)(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isPaused = _useState2[0],
      setIsPaused = _useState2[1];

  var touchStartX = 0;
  var touchEndX = 0;

  var _useState3 = (0,react.useState)(newsData === null || newsData === void 0 ? void 0 : newsData.slice(0, 5)),
      list = _useState3[0],
      setList = _useState3[1]; // Pause auto-slide on user interaction


  var pauseAutoSlide = function pauseAutoSlide() {
    setIsPaused(true); // setTimeout(() => setIsPaused(false), 5000); // Resume auto-slide after 5 seconds
  };

  var resumeAutoSlide = function resumeAutoSlide() {
    setIsPaused(false);
  }; // Handle Touch Swipe (Mobile)


  var handleTouchStart = function handleTouchStart(e) {
    touchStartX = e.touches[0].clientX;
    pauseAutoSlide();
  };

  var handleTouchEnd = function handleTouchEnd(e) {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
  };

  var handleSwipe = function handleSwipe() {
    var swipeThreshold = 50;

    if (touchStartX - touchEndX > swipeThreshold) {
      nextSlide();
    } else if (touchEndX - touchStartX > swipeThreshold) {
      prevSlide();
    }

    var obj = {
      eventName: "News_Card_Scroll",
      pageTitle: "Home Page"
    };
    (0,cricket/* callGaEvent */.ut)(obj);
  }; // Go to next slide


  var nextSlide = function nextSlide() {
    setCurrentIndex(function (prevIndex) {
      return (prevIndex + 1) % list.length;
    });
  }; // Go to previous slide


  var prevSlide = function prevSlide() {
    setCurrentIndex(function (prevIndex) {
      return prevIndex === 0 ? newsData.length - 1 : prevIndex - 1;
    });
  };

  var handleDotClick = function handleDotClick(index) {
    setCurrentIndex(index);
    var obj = {
      eventName: "News_Card_Scroll",
      pageTitle: "Home Page"
    };
    (0,cricket/* callGaEvent */.ut)(obj);
  };

  (0,react.useEffect)(function () {
    var interval = null;

    if (isPaused) {
      clearInterval(interval);
      return;
    } else {
      interval = setInterval(function () {
        setCurrentIndex(function (prevIndex) {
          return (prevIndex + 1) % list.length;
        });
      }, 3000);
    }

    return function () {
      return clearInterval(interval);
    };
  }, [isPaused]);

  var handleNewsClick = function handleNewsClick(item) {
    var obj = {
      eventName: "News_Card_Click",
      pageTitle: "Home Page"
    };
    (0,cricket/* callGaEvent */.ut)(obj);
    var type = (item === null || item === void 0 ? void 0 : item.type) == 'video' ? 'video' : 'post';
    window.location.href = "/sports/".concat(type, "/").concat(item === null || item === void 0 ? void 0 : item.postSlug);
  };

  var _onMouseEnter = function onMouseEnter() {
    pauseAutoSlide();
  };

  var _onMouseLeave = function onMouseLeave() {
    resumeAutoSlide();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "featuredCards col rounded rounded-4 ",
    style: {
      flex: "1",
      background: "#016369",
      maxWidth: "430px",
      padding: "13px 16px",
      marginTop: "1px",
      backgroundImage: "url('/assets/images/bg-news.png')",
      backgroundPosition: "right",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat"
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      onMouseEnter: function onMouseEnter() {
        return _onMouseEnter();
      },
      onMouseLeave: function onMouseLeave() {
        return _onMouseLeave();
      },
      style: {
        overflow: "hidden"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          display: "flex",
          transform: "translateX(-".concat(currentIndex * 100, "%)"),
          transition: "transform 0.7s ease-in-out"
        },
        children: list.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onClick: function onClick() {
              handleNewsClick(item);
            },
            style: {
              background: "transparent",
              borderRadius: "12px",
              padding: "8px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              flexShrink: "0",
              width: "100%",
              height: "80px",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              cursor: "pointer"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                flexShrink: 0
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item === null || item === void 0 ? void 0 : item.headingImageUrl // src = ""
                ,
                alt: "Pakistan Cricket",
                style: {
                  width: "100px",
                  height: "60px",
                  borderRadius: "8px",
                  objectFit: "contain"
                }
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              style: {
                flex: 1,
                color: "white"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                style: {
                  margin: 0,
                  fontSize: "16px",
                  fontWeight: "normal"
                },
                children: item === null || item === void 0 ? void 0 : item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  display: "flex",
                  alignItems: "center",
                  marginTop: "8px",
                  opacity: 0.8
                }
              })]
            })]
          }, index);
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        display: "flex",
        justifyContent: "center",
        gap: "8px",
        padding: "10px 0px",
        paddingBottom: "0"
      },
      children: list.map(function (_, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return handleDotClick(index);
          },
          style: {
            width: currentIndex === index ? "10px" : "8px",
            height: currentIndex === index ? "10px" : "8px",
            borderRadius: "50%",
            border: currentIndex === index ? "none" : "1.5px solid #d1d5db",
            transition: "background-color 1s ease",
            backgroundColor: currentIndex === index ? "#d9368b" : "transparent"
          }
        }, index);
      })
    })]
  });
};

/* harmony default export */ var cricket_NewsCarousel = (NewsCarousel);
;// CONCATENATED MODULE: ./src/components/homePage/mainContainer/index.js




 // import { useEffect } from "react";

 // import { QuizCard } from "components/quiz/quizCard";



 // import Sponsor from "components/Sponsor";
// import getConfig from "next/config";






 // import NewsWidget from "components/NewsWidget";




var QuickLinks = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7758), __webpack_require__.e(719), __webpack_require__.e(6779)]).then(__webpack_require__.bind(__webpack_require__, 75833));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(75833)];
    }
  }
});
var QuickLinksMobile = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1113).then(__webpack_require__.bind(__webpack_require__, 31113));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(31113)];
    }
  }
});
var DynamicBanner = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3057)]).then(__webpack_require__.bind(__webpack_require__, 43057));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43057)];
    }
  }
}); // const ReadNewsCard = dynamic(() =>
//   import("components/newsCard/readNewsCard/index.js"),{ssr:true}
// );
// const AddaBannerCategory = dynamic(() =>
//   import("components/homePage/addaBannerCategory")
// );

var LiveElectionCard = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8896).then(__webpack_require__.bind(__webpack_require__, 98896));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(98896)];
    }
  }
}); // const GoodMorning = dynamic(() =>
//   import("components/homePage/goodMorning/goodmorning")
// );

var LiveShow = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3937), __webpack_require__.e(3061)]).then(__webpack_require__.bind(__webpack_require__, 83937));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(83937)];
    }
  }
});
var NewsBannerType1 = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1267).then(__webpack_require__.bind(__webpack_require__, 11267));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(11267)];
    }
  }
}); // const NewsBannerType2 = dynamic(() => import("components/newsBanner/Type2"), {
//   ssr: true,
// });
// const CricketSlider = dynamic(
//   () => import("components/homePage/cricketSlider"),
//   { ssr: true }
// );

var MainContainer = function MainContainer(_ref) {
  var _bannerData$largeBann, _bannerData$largeBann2, _bannerData$largeBann4, _bannerData$carouselB, _masterConfig$homeIfr, _masterConfig$homeIfr2, _masterConfig$homeIfr3, _masterConfig$homeIfr4, _masterConfig$homeIfr5, _masterConfig$homeIfr6, _featuredPosts$slice, _featuredPosts$slice2, _featuredPosts$slice3, _featuredPosts$slice4, _featuredPosts$slice5, _bannerData$carouselB2, _featuredPosts$slice6, _bannerData$carouselB3, _masterConfig$homeIfr7, _masterConfig$homeIfr8, _masterConfig$homeIfr9, _masterConfig$homeIfr10, _masterConfig$homeIfr11, _masterConfig$homeIfr12;

  var _ref$featuredPosts = _ref.featuredPosts,
      featuredPosts = _ref$featuredPosts === void 0 ? [] : _ref$featuredPosts,
      _ref$bannerData = _ref.bannerData,
      bannerData = _ref$bannerData === void 0 ? [] : _ref$bannerData,
      _ref$liveShowData = _ref.liveShowData,
      liveShowData = _ref$liveShowData === void 0 ? [] : _ref$liveShowData,
      _ref$firstScroll = _ref.firstScroll,
      firstScroll = _ref$firstScroll === void 0 ? false : _ref$firstScroll,
      _ref$quizPage = _ref.quizPage,
      quizPage = _ref$quizPage === void 0 ? [] : _ref$quizPage,
      masterObj = _ref.masterObj,
      _ref$newsData = _ref.newsData,
      newsData = _ref$newsData === void 0 ? [] : _ref$newsData;
  var masterConfig = (0,react.useContext)(MasterConfigContext/* MasterConfigContext */.d);
  console.log("bannerData", masterConfig);

  var _useState = (0,react.useState)(false),
      isLiveActive = _useState[0],
      setIsLiveActive = _useState[1];

  var _useState2 = (0,react.useState)({
    electionExitPollToggle: false,
    electionResultToggle: true,
    vidhansabhaResultToggle: true,
    resultVersion: 1.6,
    exitPollVersion: 1.2,
    electionYear: 2024,
    isElectionAlpha: true,
    keyCandidate: true
  }),
      publicRuntimeConfig = _useState2[0],
      setPublicRunTimeConfig = _useState2[1];

  (0,react.useEffect)(function () {
    if ((liveShowData === null || liveShowData === void 0 ? void 0 : liveShowData.totalCount) > 0 || (liveShowpostData === null || liveShowpostData === void 0 ? void 0 : liveShowpostData.totalCount) > 0) {
      setIsLiveActive(true);
    }

    if (true) {
      var remoteConfig = (0,index_esm/* getRemoteConfig */.sN)(firebase/* default */.Z);
      remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
      (0,index_esm/* fetchAndActivate */.xS)(remoteConfig).then(function () {
        var titleData = (0,index_esm/* getString */.KF)(remoteConfig, "electionKeys");
        var parsedData = JSON.parse(titleData);
        setPublicRunTimeConfig(parsedData);
        console.log("Election Keys are ", parsedData); // setVideoUrl(titleData);
      })["catch"](function (err) {
        console.error(err);
      });
    }
  }, []);
  (0,react.useEffect)(function () {});
  var size = (0,commonConstants/* useWindowSize */.iP)();
  var router = (0,next_router.useRouter)();

  var _useState3 = (0,react.useState)(false),
      loadAfterTime = _useState3[0],
      setLoadAfterTime = _useState3[1];

  (0,react.useEffect)(function () {
    setTimeout(function () {
      setLoadAfterTime(true);
    }, [3000]);
  }, []); // const blogsListFirst = useSelector((data) => data.liveblogReducer?.blogsList);
  // const blogsList = [];
  // if (blogsListFirst.length > 0 && blogsListFirst[0].eventStatus === "live") {
  //   blogsList.push(blogsListFirst[0]);
  // }
  // console.log("Blogs list is ", blogsList);

  var _useState4 = (0,react.useState)("hindi"),
      language = _useState4[0],
      setLanguage = _useState4[1]; // useEffect(() => {
  //   setLanguage(getLanguage());
  // }, []);
  // const [isMobile,setIsMobile] = useState(false);
  // const [isDesktop, setIsDesktop] = useState(false);
  // const isMobile =
  //   typeof window !== "undefined" &&
  //   window.matchMedia("(max-width: 600px)").matches;
  // const isDesktop =
  //   typeof window !== "undefined" &&
  //   window.matchMedia("(min-width: 600px)").matches;


  var _useSelector = (0,es/* useSelector */.v9)(function (_ref2) {
    var PostReducer = _ref2.PostReducer;
    return PostReducer;
  }),
      liveShowpostData = _useSelector.liveShowpostData; // useEffect(() => {
  //   let obj = {
  //     bannerImage:
  //       "https://static.thelallantop.com/1679038971660MicrosoftTeams-image%20%289%29.png?width=400",
  //     index: 2,
  //     type: "WEBVIEW",
  //     title: "quiz",
  //     mWebBannerImage:
  //       "https://static.thelallantop.com/1679038971660MicrosoftTeams-image%20%289%29.png?width=400",
  //   };
  //   // let obj1 = {
  //   //   bannerImage:
  //   //     "https://static.thelallantop.com/images/post/1689922313619_microsoftteams-image_(10).webp?quality=40",
  //   //   index: 2,
  //   //   type: "WEBVIEW",
  //   //   title: "adda",
  //   //   deepLink: "https://adda.thelallantop.com/?userId=%22home%22",
  //   //   mWebBannerImage:
  //   //     "https://static.thelallantop.com/images/post/1689922313619_microsoftteams-image_(10).webp?quality=40",
  //   // };
  //   // if (!bannerData.includes(obj1) && window.innerWidth > 500) {
  //   //   bannerData.push(obj1);
  //   // }
  //   // if (!bannerData.includes(obj)) {
  //   //   bannerData.push(obj);
  //   // }
  //   bannerData.push(obj);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);


  console.log('bannerData["largeBannerDesktopData"]', bannerData["largeBannerDesktopData"]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "mainContainer",
    style: {
      marginBottom: "1.5rem"
    },
    children: [router.pathname === "/" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "outer-main-conainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "main-container-featured1 pt-3",
        children: [loadAfterTime && size.width > 950 && /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-3"
        }), size.width > 768 && bannerData["largeBannerDesktopData"] && ((_bannerData$largeBann = bannerData["largeBannerDesktopData"]) === null || _bannerData$largeBann === void 0 ? void 0 : _bannerData$largeBann.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: (_bannerData$largeBann2 = bannerData["largeBannerDesktopData"][0]) === null || _bannerData$largeBann2 === void 0 ? void 0 : _bannerData$largeBann2.deepLink,
          onClick: function onClick() {
            var _bannerData$largeBann3;

            ga("create", "G-RXRPKR4310", "auto");
            ga("send", "event", {
              eventCategory: "banner",
              eventAction: "Click",
              eventLabel: "featured",
              eventValue: "".concat((_bannerData$largeBann3 = bannerData["largeBannerDesktopData"][0]) === null || _bannerData$largeBann3 === void 0 ? void 0 : _bannerData$largeBann3.title)
            });
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: (_bannerData$largeBann4 = bannerData["largeBannerDesktopData"][0]) === null || _bannerData$largeBann4 === void 0 ? void 0 : _bannerData$largeBann4.bannerImage,
            className: "top-banner-image"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "content",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "left-area-Col",
            children: [console.log(' bannerData["carouselBannersMobileData"]', bannerData), size.width < 768 && bannerData["carouselBannersMobileData"] && ((_bannerData$carouselB = bannerData["carouselBannersMobileData"]) === null || _bannerData$carouselB === void 0 ? void 0 : _bannerData$carouselB.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicBanner, {
              isMobile: true,
              list: bannerData["carouselBannersMobileData"],
              type: "msite",
              page: "featured"
            }), size.width <= 950 && (masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$homeIfr = masterConfig.homeIframe) === null || _masterConfig$homeIfr === void 0 ? void 0 : _masterConfig$homeIfr.home_widget) && (masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$homeIfr2 = masterConfig.homeIframe) === null || _masterConfig$homeIfr2 === void 0 ? void 0 : (_masterConfig$homeIfr3 = _masterConfig$homeIfr2.homeIframeUrl) === null || _masterConfig$homeIfr3 === void 0 ? void 0 : _masterConfig$homeIfr3.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              style: {
                display: "relative"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                style: {
                  position: "absolute",
                  height: "116px",
                  width: "350px"
                },
                href: (_masterConfig$homeIfr4 = masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$homeIfr5 = masterConfig.homeIframe) === null || _masterConfig$homeIfr5 === void 0 ? void 0 : _masterConfig$homeIfr5.homeIframeUrlHref) !== null && _masterConfig$homeIfr4 !== void 0 ? _masterConfig$homeIfr4 : ""
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                src: masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$homeIfr6 = masterConfig.homeIframe) === null || _masterConfig$homeIfr6 === void 0 ? void 0 : _masterConfig$homeIfr6.homeIframeUrl,
                width: "100%",
                height: "126",
                style: {
                  marginTop: "-8px"
                }
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "checkDesktopOrNot",
              children: featuredPosts === null || featuredPosts === void 0 ? void 0 : (_featuredPosts$slice = featuredPosts.slice(0, 1)) === null || _featuredPosts$slice === void 0 ? void 0 : _featuredPosts$slice.map(function (postData, _) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsBannerType1, {
                    postData: postData
                  })
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "checkMobileOrNot",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LiveElectionCard, {}), loadAfterTime && /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinksMobile, {
                bannerData: bannerData
              }), featuredPosts === null || featuredPosts === void 0 ? void 0 : (_featuredPosts$slice2 = featuredPosts.slice(0, 1)) === null || _featuredPosts$slice2 === void 0 ? void 0 : _featuredPosts$slice2.map(function (postData, _) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(Type2, {
                    postData: postData
                  })
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            }), size.width < 768 && !((masterObj === null || masterObj === void 0 ? void 0 : masterObj.MoveAdsUp) == true) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "container-row py-2 mobile-header-ad",
              align: "center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                style: {
                  fontSize: "11px",
                  color: "#b7b7b7",
                  marginBottom: "0px"
                },
                children: "Advertisement"
              }), size.width < 768 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                id: "div-gpt-ad-1701946028239-0",
                style: {
                  minHeight: "260px",
                  alignContent: "center",
                  textAlign: "-webkit-center"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                  type: "text/javascript",
                  defer: true,
                  dangerouslySetInnerHTML: {
                    __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
                  }
                })
              })]
            }), featuredPosts === null || featuredPosts === void 0 ? void 0 : (_featuredPosts$slice3 = featuredPosts.slice(1, 2)) === null || _featuredPosts$slice3 === void 0 ? void 0 : _featuredPosts$slice3.map(function (postData, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "featuredCards",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReadNewsCardNew/* default */.Z, {
                  postData: postData
                }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
              }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
            }), featuredPosts === null || featuredPosts === void 0 ? void 0 : (_featuredPosts$slice4 = featuredPosts.slice(2, 5)) === null || _featuredPosts$slice4 === void 0 ? void 0 : _featuredPosts$slice4.map(function (postData, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "featuredCards",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReadNewsCardNew/* default */.Z, {
                  postData: postData
                }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
              }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
            }), isLiveActive && (featuredPosts === null || featuredPosts === void 0 ? void 0 : (_featuredPosts$slice5 = featuredPosts.slice(11, 12)) === null || _featuredPosts$slice5 === void 0 ? void 0 : _featuredPosts$slice5.map(function (postData, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "featuredCards",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReadNewsCardNew/* default */.Z, {
                  postData: postData
                }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
              }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
            }))]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "left-area-Col mobile-second-col",
            children: [(size === null || size === void 0 ? void 0 : size.width) < 768 && ((liveShowData === null || liveShowData === void 0 ? void 0 : liveShowData.totalCount) > 0 || (liveShowpostData === null || liveShowpostData === void 0 ? void 0 : liveShowpostData.totalCount) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "live-mobile",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LiveShow, {
                liveShowData: liveShowData
              })
            }), size.width > 768 && bannerData["carouselBannersDesktopData"] && ((_bannerData$carouselB2 = bannerData["carouselBannersDesktopData"]) === null || _bannerData$carouselB2 === void 0 ? void 0 : _bannerData$carouselB2.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(DynamicBanner, {
              list: bannerData["carouselBannersDesktopData"],
              type: "msite",
              page: "featured"
            }), size.width > 768 && masterConfig['ChampionsTrophyWidget']['SmallHomeBannerDesktop'] && /*#__PURE__*/(0,jsx_runtime.jsx)(cricket_NewsCarousel, {
              newsData: newsData
            }), featuredPosts === null || featuredPosts === void 0 ? void 0 : (_featuredPosts$slice6 = featuredPosts.slice(5, ((_bannerData$carouselB3 = bannerData["carouselBannersDesktopData"]) === null || _bannerData$carouselB3 === void 0 ? void 0 : _bannerData$carouselB3.length) == 0 || isLiveActive ? 11 : 10)) === null || _featuredPosts$slice6 === void 0 ? void 0 : _featuredPosts$slice6.map(function (postData, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "featuredCards",
                style: index === 0 ? {
                  marginTop: "8px"
                } : undefined,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReadNewsCardNew/* default */.Z, {
                  postData: postData
                }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
              }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
            }), size.width > 950 && (masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$homeIfr7 = masterConfig.homeIframe) === null || _masterConfig$homeIfr7 === void 0 ? void 0 : _masterConfig$homeIfr7.home_widget) && (masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$homeIfr8 = masterConfig.homeIframe) === null || _masterConfig$homeIfr8 === void 0 ? void 0 : (_masterConfig$homeIfr9 = _masterConfig$homeIfr8.homeIframeUrl) === null || _masterConfig$homeIfr9 === void 0 ? void 0 : _masterConfig$homeIfr9.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              style: {
                display: "relative"
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                style: {
                  position: "absolute",
                  height: "100px",
                  width: "350px"
                },
                href: (_masterConfig$homeIfr10 = masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$homeIfr11 = masterConfig.homeIframe) === null || _masterConfig$homeIfr11 === void 0 ? void 0 : _masterConfig$homeIfr11.homeIframeUrlHref) !== null && _masterConfig$homeIfr10 !== void 0 ? _masterConfig$homeIfr10 : ""
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                src: masterConfig === null || masterConfig === void 0 ? void 0 : (_masterConfig$homeIfr12 = masterConfig.homeIframe) === null || _masterConfig$homeIfr12 === void 0 ? void 0 : _masterConfig$homeIfr12.homeIframeUrl,
                width: "100%",
                height: "124",
                style: {
                  marginTop: "-8px"
                }
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "right-area-Col",
            children: [(size === null || size === void 0 ? void 0 : size.width) > 950 && ((liveShowData === null || liveShowData === void 0 ? void 0 : liveShowData.totalCount) > 0 || (liveShowpostData === null || liveShowpostData === void 0 ? void 0 : liveShowpostData.totalCount) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "checkDesktopOrNot",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(LiveShow, {
                liveShowData: liveShowData
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "checkDesktopOrNot",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(goodmorning, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "container-row py-2 deaktop-header-ad",
              align: "center",
              children: size.width > 950 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                id: "div-gpt-ad-1701945220410-0",
                style: {
                  minHeight: "260px",
                  alignContent: "center",
                  textAlign: "-webkit-center"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
                  type: "text/javascript",
                  dangerouslySetInnerHTML: {
                    __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-0')})"
                  }
                })
              })
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {})]
  });
};

/* harmony default export */ var mainContainer = (MainContainer);

/***/ }),

/***/ 43063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var ReadNewsCardNew = function ReadNewsCardNew(_ref) {
  var _postData$permalink;

  var postData = _ref.postData;
  var pageToOpen = postData && (postData === null || postData === void 0 ? void 0 : (_postData$permalink = postData.permalink) === null || _postData$permalink === void 0 ? void 0 : _postData$permalink.split(".com")[1]);

  function trimSentenceToWords(sentence, wordLimit) {
    // Split the sentence into words
    var words = sentence.split(' '); // Check if the number of words is more than the limit

    if (words.length > wordLimit) {
      // Slice the array to keep only the first 'wordLimit' words
      var trimmedWords = words.slice(0, wordLimit); // Join the trimmed words back into a sentence

      return trimmedWords.join(' ') + '...';
    }

    return sentence;
  }

  console.log("readNewsNEw", postData);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
    href: pageToOpen,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
      className: "news-article-small",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "news-image",
        style: {
          position: "relative"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
          className: "type-article"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
          src: (postData === null || postData === void 0 ? void 0 : postData.headingImageUrl) + "?width=200",
          className: "article-image"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
          className: "news-type-icon",
          style: {
            color: "white",
            position: "absolute",
            bottom: "2px",
            left: "4px"
          },
          children: postData.eventStatus === undefined && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
            className: "icon-".concat((postData === null || postData === void 0 ? void 0 : postData.type) === "text" || postData.type === "liveblog" ? "cat-read" : (postData === null || postData === void 0 ? void 0 : postData.type) === "audio" ? "mic" : "play-circle")
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "news-text",
        children: trimSentenceToWords(postData === null || postData === void 0 ? void 0 : postData.title, 17)
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ReadNewsCardNew);

/***/ }),

/***/ 18945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83977);

var firebaseConfig = {
  apiKey: "AIzaSyA43bFX7ueF-JM0g-weOR0HxqDuQRkXydg",
  authDomain: "thelallantop-5296b.firebaseapp.com",
  databaseURL: "https://thelallantop-5296b.firebaseio.com",
  projectId: "thelallantop-5296b",
  storageBucket: "thelallantop-5296b.appspot.com",
  messagingSenderId: "928164060644",
  appId: "1:928164060644:web:7490092b73d4b3f714bbf1",
  measurementId: "G-L0B4Q7N010"
}; // const firebaseConfig = {
//   apiKey: "AIzaSyBd9I1B7T3yq5xXY5HoU69k1OIcGSBbnHE",
//   authDomain: "lallantop-dev-c5e4c.firebaseapp.com",
//   databaseURL: "https://lallantop-dev-c5e4c-default-rtdb.firebaseio.com",
//   projectId: "lallantop-dev-c5e4c",
//   storageBucket: "lallantop-dev-c5e4c.appspot.com",
//   messagingSenderId: "606538662701",
//   appId: "1:606538662701:web:b9fd13f9130e72f8f689a4",
//   measurementId: "G-KGFH4PGD46"
// };

var app = (0,firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .initializeApp */ .ZF)(firebaseConfig, "appcheck");
/* harmony default export */ __webpack_exports__["Z"] = (app);

/***/ }),

/***/ 21253:
/***/ (function(module) {

module.exports = JSON.parse('{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","name":"Hindi News: Latest Hindi News, Breaking Hindi News Live, Today Hindi News and Headlines - TheLallantop","position":1,"item":{"@type":"Thing","@id":"https://www.thelallantop.com/"}}]}');

/***/ })

}]);